import { OrderType } from 'enums';
import { Statistics } from 'features/statistics';

export const TraderPayinStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payin} />
);
export const TraderPayoutStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payout} />
);
